<template>
  <div :class="isAboutUs ? 'bg-white' : 'bg-soft-gray'" class="w-full featured-partnership px-14 lg:px-30 py-90">
    <div class="featured container flex flex-col justify-center mb-50 lg:mb-50">
      <h2 class="text-24 lg:text-32 font-display font-bold whitespace-pre-line text-center mb-30">Featured in</h2>
      <div class="grid grid-cols-2 gap-20 md:inline-flex md:flex-wrap md:gap-x-10 md:gap-y-20 justify-center items-center content-center">
        <div class="flex items-center justify-center" v-for="(feature, index) in featured" :key="index">
          <img :src="feature.image" :alt="feature.name" class="h-80 object-contain" draggable="false"/>
        </div>
      </div>
    </div>
    <div class="partnerships container flex flex-col justify-center">
      <h2 class="text-24 lg:text-32 font-display font-bold whitespace-pre-line text-center mb-30">Partners with</h2>
      <div class="grid grid-cols-2 gap-20 md:inline-flex md:flex-wrap md:gap-x-10 md:gap-y-20 justify-center items-center content-center">
        <div class="flex items-center justify-center" v-for="(partner, index) in partners" :key="index">
          <img :src="partner.image" :alt="partner.name" class="h-80 object-contain" draggable="false"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { register } from 'swiper/element/bundle';
import 'swiper/swiper-bundle.css';

register();

// Featured
import ManilaBulletin from "./../../../assets/images/featured/manila-bulletin.png"
import SpotPH from "./../../../assets/images/featured/spot-ph.png"
import PhilDailyInquirer from "./../../../assets/images/featured/philippine-daily-inquirer.png"
import InquirerNet from "./../../../assets/images/featured/inquirer-net.png"
import ThePhilStar from "./../../../assets/images/featured/the-philippine-star.png"
import RealLiving from "./../../../assets/images/featured/real-living.png"
import Paymongo from "./../../../assets/images/featured/paymongo.png"
import DailyTribune from "./../../../assets/images/featured/daily-tribune.png"
import MorningBalitaktakan from "./../../../assets/images/featured/morning-balitaktakan.png"
import DWIZ from "./../../../assets/images/featured/dwiz.png"
import LifestyleAsia from "./../../../assets/images/featured/lifestyle-asia.png"
import Upsize from "./../../../assets/images/featured/upsize-ph.png"
import TheManilaTimes from "./../../../assets/images/featured/manila-times.png"
import LifestyleINQ from "./../../../assets/images/featured/lifestyle-inq.png"
import ClickTheCity from "./../../../assets/images/featured/click-the-city.png"
import WhenInManila from "./../../../assets/images/featured/when-in-manila.png"
import BusinessMirror from "./../../../assets/images/featured/business-mirror.png"
import ManilaStandard from "./../../../assets/images/featured/manila-standard.png"
import Tatler from "./../../../assets/images/featured/tatler.png"
import ABSCBNNews from "./../../../assets/images/featured/abs-cbn-news.png"

// Partners
import FreelanceWriter from "./../../../assets/images/partners/freelance-writers-guild-ph.png"
import AWPI from "./../../../assets/images/partners/awpi.png"
import FrAls from "./../../../assets/images/partners/fr-als-children-foundation-inc.png"
import HSBC from "./../../../assets/images/partners/hsbc.png"
import MMOWellness from "./../../../assets/images/partners/mmo-wellness-center.png"
import CaraPH from "./../../../assets/images/partners/cara-philippines.png"
import Watsons from "./../../../assets/images/partners/watsons.png"

export default {
  name: "FeaturedPartnerships",

  props: {
    isAboutUs: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      featured: [
        { image: ManilaBulletin, name: "Manila Bulletin" },
        { image: SpotPH, name: "Spot PH" },
        { image: PhilDailyInquirer, name: "Philippine Daily Inquirer" },
        { image: InquirerNet, name: "Inquirer.net" },
        { image: ThePhilStar, name: "The Philippine Star" },
        { image: RealLiving, name: "Real Living" },
        { image: Paymongo, name: "Paymongo" },
        { image: DailyTribune, name: "Daily Tribune" },
        { image: MorningBalitaktakan, name: "Morning Balitaktakan" },
        { image: DWIZ, name: "DWIZ" },
        { image: LifestyleAsia, name: "Lifestyle Asia" },
        { image: Upsize, name: "Upsize" },
        { image: TheManilaTimes, name: "The Manila Times" },
        { image: LifestyleINQ, name: "Lifestyle INQ" },
        { image: ClickTheCity, name: "Click The City" },
        { image: WhenInManila, name: "When In Manila" },
        { image: BusinessMirror, name: "Business Mirror" },
        { image: ManilaStandard, name: "Manila Standard" },
        { image: Tatler, name: "Tatler" },
        { image: ABSCBNNews, name: "ABS-CBN News" },
      ],
      partners: [
        { image: MMOWellness, name: "MMO Wellness Center" },
        { image: HSBC, name: "HSBC" },
        { image: FrAls, name: "Fr. Al's Children Foundation Inc." },
        { image: AWPI, name: "AWPI" },
        { image: FreelanceWriter, name: "Freelance Writers Guild PH" },
        { image: CaraPH, name: "Cara Philippines" },
        { image: Watsons, name: "Watsons" },
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.featured-partnership {
  &.bg-soft-gray {
    background-color: #F8F8F8;
  }

  swiper-slide {
    width: 150px !important;
  }
}
</style>